import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeBillingListItem extends SearchModelBase {
    code: string = '';
    desc1: string = '';
    jobType: string = '';
    localDesc: string = '';
    salesGLNo: string = '';
    salesGLNoDesc: string = '';
    costGLNo: string = '';
    costGLNoDesc: string = '';
    inactive: boolean|null = null;
    inactiveDate: string | null = null;
    remark: string = '';
    id: number = 0;
    isDefault: boolean = false;
    billingCodeIndex: string = '';


    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Billing Code', width: 200, dataIndex: 'code'}),
        XCol.Create({ col: 1, text: 'Default Description', width: 300, dataIndex: 'desc1'}),
        XCol.Create({ col: 2, text: 'Job Type', width: 170, dataIndex: 'jobType'}),
        XCol.Create({ col: 3, text: 'Custom Description', width: 300, dataIndex: 'localDesc'}),
        XCol.Create({ col: 4, text: 'Sales Acct.Code', width: 100, dataIndex: 'salesGLNo'}),
        XCol.Create({ col: 5, text: 'Sales Acct.Code Desc.', width: 200, dataIndex: 'salesGLNoDesc'}),
        XCol.Create({ col: 6, text: 'Cost Acct.Code', width: 100, dataIndex: 'costGLNo'}),
        XCol.Create({ col: 7, text: 'Cost Acct.Code Desc.', width: 200, dataIndex: 'costGLNoDesc'}),
        XCol.Create({ col: 8, text: 'Inactive', width: 65, dataIndex: 'inactive', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 9, text: 'Inactive Date', width: 65, dataIndex: 'inactiveDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 10, text: 'Remark', width: 400, dataIndex: 'remark'})
        ];

    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeBillingListItem.prototype.code, orderByAscending: false };

    public static formatData(data: CodeBillingListItem[]) {
        return data.map((d: CodeBillingListItem) => ({
          ...d,
        }));
    }

}
